import { scheduleIsCurrent } from 'lib/offer/scheduleStatusUtils'
import { PACKAGE_UPGRADE_ALLOWED_OFFER_IDS } from 'lib/offer/packageUpgradeAllowlist'

/**
 * Checks if self-service rebook/upgrade is allowed for an offer.
 * For allowlisted offers, uses canUpgradePackage flag which has relaxed criteria for flash hotels
 * (allows upgrades outside policy deadline as long as within book-by date and 48h before check-in).
 * For all other offers, falls back to the existing canAutoRefund check.
 */
export function isSelfServiceRebookAllowed(offer?: App.Offer, order?: App.Order, cancellationConfig?: App.OrderItemHotelCancellationConfig): boolean {
  if (!offer) return false
  if (order?.orderGift) return false

  if (PACKAGE_UPGRADE_ALLOWED_OFFER_IDS.has(offer.id)) {
    // Use canUpgradePackage for allowlisted offers - relaxed criteria for flash hotels
    if (!cancellationConfig?.canUpgradePackage) return false
  } else {
    // Fall back to canAutoRefund for all other offers (pre-existing behaviour)
    if (!cancellationConfig?.canAutoRefund) return false
  }

  return !!offer.packageUpgradesAllowed && scheduleIsCurrent(offer.onlinePurchaseSchedule)
}
